
import Category from "@/types/Category";
import { useForm } from "@inertiajs/inertia-vue3";
import { defineComponent, PropType } from "vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading } from "@mdi/js";
import CategorySelect from "../Forms/CategorySelect.vue";
import SupplierSelect from "../Forms/SupplierSelect.vue";
import Multiselect from "../General/Multiselect.vue";


export default defineComponent({
  props: {
    categories: {
      type: Object as PropType<Category[]>,
      required: true,
    },
    suppliers: {
      type: Object as PropType<Category[]>,
      required: true,
    },
    form: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const defaultValues = {
      name: "",
      categories: [] as number[],
      suppliers: [] as number[],
      type: [],
      brandFilter: "all",
      noWeight: false,
      noBarcode: false,
      noImage: false,
      noDescription: false,
      noMinimumStock: false,
      featuredProduct: false,
      onSale: false,
      outOfProduction: false,
      negativeStock: false,
      includeProducts: true,
    };
    const form = useForm({ ...defaultValues, ...props.form });
    const options = [
      { label: "Enkeltprodukter", id: "simple" },
      { label: "Variable produkter", id: "variable" },
      { label: "Varianter", id: "variation" },
      { label: "Enkelt treningsabonnement", id: "subscription" },
      { label: "Variable treningsabonnement", id: "variable-subscription" },
      { label: "Treningsabonnement varianter", id: "subscription-variation" },
    ];

    const submit = () => {
      form.get(route("products.index"));
    };

    return {
      submit,
      form,
      loadingIcon: mdiLoading,
      options,
    };
  },
  components: { Button, SvgIcon, CategorySelect, SupplierSelect, Multiselect },
});
